import React from "react";
import Payments from "./Payments";


const PaymentsAchat = () => {
    return <Payments tierLabel="Fournisseur" tiersApi="Suppliers" />;
};

export default PaymentsAchat;
